import { Controller } from "@hotwired/stimulus"

// Guards against rescheduling multiple classes by accident: submitting any one
// "Anotarme" button locks every other slot button on the page until the
// request finishes, so rapid clicks can't fire off several recoveries before
// the page has a chance to reflect the first one.
export default class extends Controller {
  static targets = ["button"]

  lock() {
    this.buttonTargets.forEach((button) => {
      button.disabled = true
      button.classList.add("opacity-50", "cursor-not-allowed")
    })
  }

  unlock() {
    this.buttonTargets.forEach((button) => {
      button.disabled = false
      button.classList.remove("opacity-50", "cursor-not-allowed")
    })
  }
}
